import { SSOCrypto } from '../types';

/**
 * Convert a decimal number to a hex string.
 * @param decimal
 */
function decimalToHex(decimal: number) {
  return decimal.toString(16).padStart(2, '0');
}

/**
 * Generates a cryptographically safe random string of length `length`.
 * @param length
 * @param crypto
 */
export function generateRandomString(length: number, crypto: SSOCrypto) {
  const randomValues = crypto.getRandomValues(new Uint8Array(Math.ceil(length / 2)));
  return Array.from(randomValues, decimalToHex).join('');
}

/**
 * Hash a string using SHA-256
 * @param str
 * @param crypto
 */
export function sha256(str: string, crypto: SSOCrypto) {
  const encoder = new TextEncoder();
  const data = encoder.encode(str);
  return crypto.subtle.digest('SHA-256', data);
}

export function arrayBufferToHexString(buffer: ArrayBuffer) {
  const byteArray = new Uint8Array(buffer);
  return Array.from(byteArray, decimalToHex).join('');
}

/**
 * Used for encoding a pkce challenge. Encoding rules taken from OAuth 2.0 RFC 7636
 * https://datatracker.ietf.org/doc/html/rfc7636#section-4.1
 * @param hashBuffer
 */
export function base64URLEncode(hashBuffer: ArrayBuffer) {
  const bytes = new Uint8Array(hashBuffer);
  const encoded = btoa(String.fromCharCode(...bytes));
  return encoded.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}
